module.exports = __webpack_public_path__ + "static/ios-3b581a09464b9d8fa4e2d9e1456583ba.svg";